import { CMSResource } from "app/resources/cmsresource";
import { DepartmentResource } from "./DepartmentResource";

export class DepartmentListResource extends CMSResource {
    departmentList: DepartmentResource[];
}